import { z } from "zod";
import { ExpertProfileSchema } from "./common";

export const ExpertProfileResponseSchema = ExpertProfileSchema;

export type ExpertProfileResponse = z.infer<typeof ExpertProfileResponseSchema>;

export const ExpertEmailChangeRequestResponseSchema = z.object({
    new_email: z.email(),
    expires_at: z.string(),
});

export type ExpertEmailChangeRequestResponse = z.infer<typeof ExpertEmailChangeRequestResponseSchema>;

export const ExpertVerifyEmailChangeResponseSchema = z.object({
    email: z.email(),
});

export type ExpertVerifyEmailChangeResponse = z.infer<typeof ExpertVerifyEmailChangeResponseSchema>;
